export default Object.freeze([
    'aqueduct',
    'area',
    'well',
    'other',
]);
